import API from '@/services/api'

// Actions
export const FETCH_INSPECTIONS = 'fetchInspections'
export const FETCH_INSPECTION = 'fetchInspection'
export const FETCH_LAST_INSPECTION = 'fetchLastInspection';
export const CREATE_INSPECTION = 'createInspection'
export const UPDATE_INSPECTION = 'updateInspection'
export const DELETE_INSPECTION = 'deleteInspection'

// Mutations
export const STORE_SET_INSPECTIONS = 'storeSetInspections'
export const STORE_ADD_INSPECTION = 'storeAddInspection'
export const STORE_UPDATE_INSPECTION = 'storeUpdateInspection'
export const STORE_DELETE_INSPECTION = 'storeDeleteInspection'

const state = {
	inspections: [],
}

const getters = {
	inspections (state) {
		return state.inspections
	},
}

const actions = {
	[FETCH_INSPECTIONS] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('inspections/' + options.property).then((response) => {
				context.commit(STORE_SET_INSPECTIONS, response.data)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[FETCH_INSPECTION] (context, options) {
		return new Promise((resolve, reject) => {
			API.query('inspections/' + options.property + '/' + options.inspection ).then((response) => {
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
	[CREATE_INSPECTION] (context, options) {
		return new Promise((resolve, reject) => {
			API.post('inspections/' + options.property, options.data).then((response) => {
				context.commit(STORE_ADD_INSPECTION, response.data);
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[UPDATE_INSPECTION] (context, options) {
		return new Promise((resolve, reject) => {
			API.update('inspections/' + options.property, options.inspection, options.changes).then((response) => {
				context.commit(STORE_UPDATE_INSPECTION, response.data)
				resolve(response.data)
			}).catch(({ response }) => {
				reject(response.data)
			})
		})
	},
	[DELETE_INSPECTION] (context, options) {
		return new Promise((resolve, reject) => {
			API.delete('inspections/' + options.property + '/' + options.inspection ).then((response) => {
				context.commit(STORE_DELETE_INSPECTION, options.inspection)
				resolve(response.data)
			}).catch((response) => {
				reject(response)
			})
		})
	},
}

const mutations = {
	[STORE_SET_INSPECTIONS] (state, inspections) {
		state.inspections = inspections
	},
	[STORE_ADD_INSPECTION] (state, inspection) {
		state.inspections.push(inspection)
	},
	[STORE_UPDATE_INSPECTION] (state, inspection) {
		let inspections = []

		state.inspections.map((mapInspection) => {
			if (mapInspection.id === inspection.id) {
				mapInspection = inspection
			}

			inspections.push(mapInspection)
		})

		state.inspections = inspections
	},
	[STORE_DELETE_INSPECTION] (state, inspection) {
		state.inspections.splice(state.inspections.indexOf(inspection), 1)
	},
}

export default { state, getters, actions, mutations }